import { SwitchProductModule } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../components';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
import { useAnonymous } from './useAnonymous';
export const useEffectiveRecommendation = (productId, catalogIsRecommended) => {
  const module = useCurrentModule();
  const {
    isEnabled,
    isLoading
  } = useAiRecommendationEnabled();
  const isRevealed = module.SDK.aiRecommendationStore.useIsRevealed();
  const aiRecommendedProductId = module.SDK.aiRecommendationStore.useRecommendedProductId();
  const {
    isAnonymous
  } = useAnonymous();
  const aiPickAvailability = SwitchProductModule.SDK.hooks.useProductAvailability({
    productId: aiRecommendedProductId ?? ''
  });
  const isAiPickUnavailable = !isAnonymous && !aiPickAvailability.isLoading && !aiPickAvailability.isProductAvailable;
  if (isLoading) {
    return {
      isRecommended: false,
      isAiRecommended: false
    };
  }
  if (!isEnabled) {
    return {
      isRecommended: catalogIsRecommended,
      isAiRecommended: false
    };
  }
  const isAiPickPending = !isAnonymous && Boolean(aiRecommendedProductId) && aiPickAvailability.isLoading;
  if (isAiPickPending) {
    return {
      isRecommended: false,
      isAiRecommended: false
    };
  }

  // Revealed with nothing to show (the tier call never settled, or it chose a
  // plan this visitor cannot buy): the catalog pick beats no badge.
  if (isRevealed && (!aiRecommendedProductId || isAiPickUnavailable)) {
    return {
      isRecommended: catalogIsRecommended,
      isAiRecommended: false
    };
  }
  const isAiRecommended = isRevealed && !!aiRecommendedProductId && aiRecommendedProductId === productId;
  return {
    isRecommended: isAiRecommended,
    isAiRecommended
  };
};
//# sourceMappingURL=useEffectiveRecommendation.js.map